package org.vreo.devicehub.features.vrmOutput.presentation

/**
 * Vrm vrm output ui actions
 */
sealed interface VrmOutputActions {
    data object OnClearError : VrmOutputActions
    data object OnLoadCurrentVrmConfigClicked : VrmOutputActions
    data object OnSaveClicked : VrmOutputActions

    // VRM list management
    data class OnUpdateSelectedVrm(val id: Int) : VrmOutputActions
    data class OnDeleteVrm(val id: Int) : VrmOutputActions
    data object OnAddVrm : VrmOutputActions


    // Main configuration
    data class OnUpdateReportingToDeviceHub(val value: Boolean) : VrmOutputActions
    data class OnUpdateVrmEnable(val value: Boolean) : VrmOutputActions
    data class OnUpdateVrmType(val index: Int) : VrmOutputActions
    data class OnUpdateVrmEndpoint(val value: String) : VrmOutputActions
    data class OnUpdateVrmApiKey(val value: String) : VrmOutputActions
    data class OnUpdateVrmSiteId(val value: String) : VrmOutputActions
    data class OnUpdateBayIdMode(val value: Boolean) : VrmOutputActions
    data class OnUpdateRoiBayIdIndex(val value: Int) : VrmOutputActions
    data class OnUpdateVrmBayIdentifier(val value: String) : VrmOutputActions
    data class OnUpdateVrmConfidenceThreshold(val value: String) : VrmOutputActions
    data class OnUpdateVrmTimeoutSeconds(val value: String) : VrmOutputActions
    data class OnUpdateVrmVerifySsl(val value: Boolean) : VrmOutputActions

    // Overlayer
    data class OnUpdateOverlayerEnable(val value: Boolean) : VrmOutputActions
    data class OnUpdateOverlayerPosition(val index: Int) : VrmOutputActions
    data class OnEnableOverlayerLabel(val value: Boolean) : VrmOutputActions
    data class OnUpdateOverlayerLabel(val value: String) : VrmOutputActions
    data class OnEnableOverlayerOcrResults(val value: Boolean) : VrmOutputActions
    data class OnEnableOverlayerBayId(val value: Boolean) : VrmOutputActions
    data class OnEnableOverlayerSiteId(val value: Boolean) : VrmOutputActions
    data class OnEnableOverlayerDateTime(val value: Boolean) : VrmOutputActions
    data class OnUpdateTimeZoneIndex(val value: Int) : VrmOutputActions
}